module.exports = __webpack_public_path__ + "img/mapping.aac082e5.png";